import { memo } from "react";

export const EmptyTableRow = memo(({ columns }: { columns?: { length: number } }) => {
    return (
        <tr>
            <td colSpan={columns?.length || 1} className="text-center"><h6 className="text-muted my-4">No data to display</h6></td>
        </tr>
    );
})